import React from 'react'
import './Portfolio.css';
import {Swiper, SwiperSlide} from 'swiper/react';
import Sidebar from "../../img/sidebar.png";
import Ecommerce from "../../img/ecommerce.png";
import HOC from "../../img/hoc.jpeg";
import MusicApp from "../../img/musicapp.png";
import 'swiper/css';
import {themeContext} from '../../Context'
import { useContext } from 'react';

const Portfolio = () => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;

  return (
    <div className="portfolio" id='Portfolio'>

        {/* heading */}
        <span style={{color: darkMode? 'white':''}}>Recent Projects</span>
        <span>Portfolio</span>


        {/* slider */}
        <Swiper
        autoplay={{ delay: 3000 }}
        spaceBetween={30}
        slidesPerView={3}
        grabCursor={true}
        className='portfolio-slider'
        >
            <SwiperSlide>
                <a href="#">
                <img src={Sidebar} alt="" />
                </a>
            </SwiperSlide>

            <SwiperSlide>
            <a href="https://github.com/RatikantPatil01/Library-Manegment">
                <img src={Ecommerce} alt="" />
                </a>
            </SwiperSlide>

            <SwiperSlide>
            <a href="#">
                <img src={MusicApp} alt="" />
                </a>
            </SwiperSlide>

            <SwiperSlide>
            <a href="https://github.com/RatikantPatil01/Django_E-Commerce_Website">
                <img src={HOC} alt="" />
                </a>
            </SwiperSlide>





        </Swiper>
    </div>
  )
}

export default Portfolio